import { SFC } from 'react'
import OriginalRow from 'reactstrap/lib/Row'

interface RowProps extends React.HTMLProps<HTMLElement> {
  tag?: React.ReactType
  noGutters?: boolean
}

export const Row = OriginalRow as SFC<RowProps>



// WEBPACK FOOTER //
// ./src/modules/flex-layout/row.tsx